
import { createBrowserRouter, RouterProvider,BrowserRouter } from 'react-router-dom'
import { routeReport } from './routerReport/routerReport';


const router = createBrowserRouter([
  {
    path: "/",
    element: <div></div>,
  },
  ...routeReport,
]);


export default ()=>{

  return  <RouterProvider router={router} />
}